import Header from "./header";

export default function Layout({ children }) {
    return <div className="h-screen flex flex-col">
        <Header />
        <main className="w-full flex-grow overflow-y-auto focus:outline-none z-0">
            {children}
        </main>
    </div>
}